export default {
  index: [
    {
      path: '/ciwubb',
      component: resolve => require(['./ciwubbIndex.vue'], resolve),
    },
    {
      path: '/zcfcbb',
      component: resolve => require(['./zcfzbbIndex.vue'], resolve),
    },
    {
      path: '/xmbb',
      component: resolve => require(['./xmIndex.vue'], resolve),
    },

    {
      path: '/shuijinbb',
      component: resolve => require(['./shuijinbbIndex.vue'], resolve),
    },
    {
      path: '/xmjsbb',
      component: resolve => require(['./xmjsbbIndex.vue'], resolve),
    },
    {
      path: '/zjbd',
      component: resolve => require(['./zjbdIndex.vue'], resolve),
    },
  ]
}



// WEBPACK FOOTER //
// ./src/view/caiwubb/_router.js